var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78226 2.10593C4.69554 2.11382 4.55862 9.58564 4.55862 10.1511C4.55862 12.4321 4.55862 14.7131 4.55862 16.994C4.55862 17.5065 4.41879 18.1227 4.57105 18.6212C4.81223 19.4108 5.14583 18.7989 5.45316 18.2957C5.98701 17.4218 7.34097 16.791 7.96282 15.9364C8.16017 15.6652 10.3772 13.5771 10.3855 13.5861C11.1158 14.3832 12.0776 15.1337 13.007 15.8099C13.9856 16.5219 14.9996 17.4449 16.1876 17.9251C16.2719 17.9592 17.6848 18.5384 17.4797 18.6664C17.3056 18.7749 17.3057 18.0525 17.3057 17.9703C17.3057 17.2652 17.3057 16.5602 17.3057 15.8551C17.3057 13.7941 17.3057 11.733 17.3057 9.67202C17.3057 7.61578 17.0821 5.5888 17.0821 3.57034C17.0821 3.36455 16.9709 2.28954 16.8088 2.14209C16.4822 1.84505 14.6952 2.10593 14.0506 2.10593C10.9612 2.10593 7.87171 2.10593 4.78226 2.10593Z",
    stroke: "#12C0B5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave5);
export default __webpack_public_path__ + "static/media/icon-save5.91b9f7ddad0b0bd45da3bbc713d8756c.svg";
export { ForwardRef as ReactComponent };